module.exports = "/images/match.svg?9c7ac74b3fb0c64bff39f41fd4ad33a5";